import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import store from './redux/store';
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';


let persistor = persistStore(store);

   //export const BASE_URL="https://chat.onexgames.in"
//  export const BASE_URL = process.env.REACT_APP_BASE_URL;

 const BASE_URL = '/api/v1';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
        <Toaster />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();